import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataModelsService {

  constructor() {

  }


  creteAddressOBJ(data) {
    console.log(JSON.stringify(data) + "::::::::::::")
    return {
      deliveryarea: data.deliveryarea,
      name: data.name,
      phn: data.phn,
      email: data.email,
      buildingname: data.buildingname,
      flatno: data.flatno,
      completeaddress: data.completeaddress,
      deliveryinstructions: data.deliveryinstructions,
      type: data.type,
      latitude: data.latitude,
      longitude: data.longitude,
      cssclass: data.class,
      default: data.default,
      mobile: localStorage.getItem("ccId")
    }
  }

}
